import { render, staticRenderFns } from "./Klaas.vue?vue&type=template&id=a292249c&scoped=true&"
import script from "./Klaas.vue?vue&type=script&lang=js&"
export * from "./Klaas.vue?vue&type=script&lang=js&"
import style0 from "./Klaas.vue?vue&type=style&index=0&id=a292249c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a292249c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
